module.exports = __webpack_public_path__ + "static/Singapore-becb49bee161025fb9935f71721b237d.png";